import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./userMenuMobile.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import equalityFn from 'zustand/shallow';
import { USER_MENU_IDENTIFIER } from '~/components/ace/userMenu/userMenu';
import { clearAuthenticationContext } from '~/modules/analytics/authenticationContext';
import { IS_DEVELOPMENT, TBID_MOCK_USER, TBID_URL } from '~/modules/config';
import { getUserLanguage } from '~/modules/helpers/languageHelper';
import { generateBaseUrl, logout } from '~/modules/helpers/routingHelper';
import { i18nStore, selectI18nModule } from '~/modules/stores/i18nStore';
import { selectIsAuthenticated, userStore } from '~/modules/stores/userStore';
import { createCookie } from '~/modules/utilities/cookies';
import { ENGLISH_LANGUAGE_CODE } from '~/modules/utilities/language_utils';
class UserMenuMobile extends LightningElement {
  constructor(...args) {
    super(...args);
    this.hideTitle = false;
    this.i18n = void 0;
    this.user = void 0;
  }
  connectedCallback() {
    this.subscribeToLogoutTransition();
  }
  disconnectedCallback() {
    this.unsubscribeUserStore?.();
  }
  subscribeToLogoutTransition() {
    this.previousIsLoggedIn = selectIsAuthenticated(userStore.getState());
    this.unsubscribeUserStore = userStore.subscribe(state => {
      const currentIsLoggedIn = selectIsAuthenticated(state);
      // Detect transition from logged in to logged out
      if (this.previousIsLoggedIn === true && currentIsLoggedIn === false) {
        this.dispatchEvent(new CustomEvent('requestclose', {
          bubbles: true,
          composed: true
        }));
      }
      this.previousIsLoggedIn = currentIsLoggedIn;
    });
  }

  // The V2 mobile detail pane supplies its own inline padding, so the embedded variant must not indent again.
  get containerClass() {
    return this.hideTitle ? 'user-menu-mobile user-menu-mobile_flush' : 'user-menu-mobile';
  }
  get title() {
    return this.i18n?.header?.myAccount?.() ?? 'My Account';
  }
  get showUser() {
    return !!this.user?.tbidProfile?.active;
  }
  get profileName() {
    const tbidProfile = this.user?.tbidProfile;
    return this.i18n?.shared?.userName?.({
      FIRST_NAME: tbidProfile?.given_name,
      LAST_NAME: tbidProfile?.family_name
    });
  }
  get profileImage() {
    return this.user?.tbidProfile?.picture;
  }
  get menuItems() {
    const items = [{
      id: 'profile',
      text: this.i18n?.header?.profile?.(),
      link: `${TBID_URL}/id`
    }, {
      id: 'settings',
      text: this.i18n?.header?.settings?.(),
      link: `${TBID_URL}/settings`
    }];
    if (getUserLanguage() === ENGLISH_LANGUAGE_CODE && this.user?.canCheckout && this.user?.canInstall) {
      items.push({
        id: 'myInstalls',
        text: this.i18n?.header?.myInstalls?.(),
        link: `${generateBaseUrl()}/appxMyAccount`
      });
    }
    items.push({
      id: 'logout',
      text: this.i18n?.header?.logout?.(),
      link: '#'
    });
    return items;
  }
  get mainMenuItems() {
    const items = this.menuItems;
    return items.length > 1 ? items.slice(0, -1) : [];
  }
  get logoutItem() {
    const items = this.menuItems;
    return items.length > 0 ? items[items.length - 1] : null;
  }

  // @ts-expect-error * Automated Type Error Fix
  handleAnalytics(event) {
    const linkClicked = event.target?.querySelector?.('a');
    const clickText = linkClicked?.textContent?.toLowerCase() || USER_MENU_IDENTIFIER;
    event.detail.navLink = {
      menuItem: USER_MENU_IDENTIFIER,
      clickText,
      clickUrl: linkClicked?.getAttribute?.('href'),
      destinationType: 'internal',
      ctaClick: false,
      navLevel: linkClicked ? 'l2' : 'l1'
    };
    event.detail.elementType = 'loginNavLink';
  }
  handleLogoutClick(event) {
    event.preventDefault();
    if (IS_DEVELOPMENT && TBID_MOCK_USER) {
      userStore.reset();
      clearAuthenticationContext();
      createCookie('sid', '', -1);
    } else {
      logout();
    }
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(UserMenuMobile, {
  publicProps: {
    hideTitle: {
      config: 0
    }
  },
  wire: {
    i18n: {
      adapter: WireStore,
      dynamic: [],
      config: function ($cmp) {
        return {
          store: i18nStore,
          selector: selectI18nModule
        };
      }
    },
    user: {
      adapter: WireStore,
      dynamic: [],
      config: function ($cmp) {
        return {
          store: userStore,
          selector: state => ({
            canInstall: state.canInstall,
            canCheckout: state.canCheckout,
            tbidProfile: state.tbidProfile
          }),
          equalityFn
        };
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(UserMenuMobile, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;